<template>
  <section class="feature-introduction-editor mx-4 mt-4">
    <div class="row mb-4">
      <div class="col main-action-panel">
        <sc-button variant="primary me-2">บันทึก</sc-button>
        <sc-button variant="danger">ลบทั้งประกาศ</sc-button>
      </div>
    </div>
    <div class="detail row">
      <div class="col col-2 platform-col px-4 py-4">
        <h3>OS ที่ต้องการประกาศ</h3>
        <div>
          <el-checkbox
            :value="form.platform.android.isSelected"
            label="Android"
            @input="setPlatformField('android', 'isSelected', $event)"
          ></el-checkbox>
          <el-input
            :value="form.platform.android.version"
            :disabled="!form.platform.android.isSelected"
            placeholder="version"
            @input="setPlatformField('android', 'version', $event)"
          ></el-input>
          <el-checkbox
            :value="form.platform.iOS.isSelected"
            label="iOS"
            @input="setPlatformField('iOS', 'isSelected', $event)"
          ></el-checkbox>
          <el-input
            :value="form.platform.iOS.version"
            :disabled="!form.platform.iOS.isSelected"
            placeholder="version"
            @input="setPlatformField('iOS', 'version', $event)"
          ></el-input>
        </div>
      </div>
      <div class="col py-4 page-col px-4">
        <h3>หน้าสำหรับประกาศ</h3>
        <FeatureIntroductionPageEditor
          :page-list="form.pageList"
          @textInputChange="handleOnTextInputChange"
          @deletePage="handleOnDeleteFeatureIntroductionPage"
          @imageChange="handleOnImageChange"
        />
        <sc-button variant="primary" @click="onAddPage">เพิ่มหน้า</sc-button>
      </div>
    </div>
  </section>
</template>

<script>
import { Input, Checkbox } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import { FeatureIntroductionPresenter } from "@/presenters/featureIntroduction/FeatureIntroductionPresenter"
import FeatureIntroductionPageEditor from "./FeatureIntroductionPageEditor"

export default {
  components: {
    ScButton,
    "el-input": Input,
    "el-checkbox": Checkbox,
    FeatureIntroductionPageEditor,
  },
  props: {
    form: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    featureIntroductionPresenter() {
      return new FeatureIntroductionPresenter(this.form)
    },
  },
  methods: {
    onAddPage() {
      this.$emit("addPage")
    },
    handleOnTextInputChange(valueChanged) {
      this.$emit("textInputChange", valueChanged)
    },
    handleOnImageChange(imageChanged) {
      this.$emit("imageChanged", imageChanged)
    },
    handleOnDeleteFeatureIntroductionPage(pageIndexToDelete) {
      this.$emit("deletePage", pageIndexToDelete)
    },
    setPlatformField(platform, field, value) {
      this.$emit("platformFieldChange", { platform, field, value })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

h3 {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.1px;
  color: #000;
  margin-bottom: 20px;
}

.feature-introduction-editor {
  height: 100%;
  .main-action-panel {
    display: flex;
    justify-content: flex-start;
  }
  .detail {
    height: 100%;
  }
  .platform-col {
    height: 100%;
    min-width: 244px;
  }
  .page-col {
    border-left: 1px solid #dcdfe6;
  }
  .version-container {
    display: grid;
    grid-template-columns: 220px auto;
  }
}
</style>
